// src/components/ui/LoadingSpinner/LoadingSpinner.jsx
import React from "react";

const LoadingSpinner = ({ size = "medium", color = "primary" }) => {
  const sizeClasses = {
    small: "w-4 h-4 border-2",
    medium: "w-5 h-5 border-2",
    large: "w-6 h-6 border-[3px]",
  };

  const colorClasses = {
    primary: "text-accent",
    white: "text-white",
    secondary: "text-text-secondary",
  };

  return (
    <div className={`inline-block relative ${colorClasses[color]}`}>
      <div
        className={`rounded-full border-transparent border-t-current border-r-current animate-spin ${sizeClasses[size]}`}
      ></div>
    </div>
  );
};

export default LoadingSpinner;
